import React, {memo, useCallback, useMemo, useRef, useState} from 'react';
import {Layout} from "antd";
import {Content} from "antd/es/layout/layout";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './style.scss'
import IndustryQuotes from "./components/ProCaseStudies/ProCaseStudies";
import butcombeHero from './img/butcombe-hero.png'
import butcombeLogo from './img/butcombe-logo.png'
import img1 from './img/Cosimo.jpg'
import img2 from './img/Textura (Walnut) - Hertford College - Oxford (2) 1.png'
import img3 from './img/Stourbridge Glass Museum.jpg'
import img4 from './img/Uncle Leo Noodle.jpg'
import img5 from './img/Core Marketing.jpg'
import img6 from './img/Yoxly.jpg'
import img7 from './img/Keble_College.png'
import img8 from './img/Meta.jpg'
import img9 from './img/HolidayInn.jpg'
import img10 from './img/Holiday_Inn_Landscape_Case_Study_55.jpeg'
import ContactSection from "./components/ContactSection";
import leftScroll from "../../pages/Home/img/LeftScroll.png";
import rightScroll from "../../pages/Home/img/RightScroll.png";

const StoryProgressLine = ({active}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="4" viewBox="0 0 30 4" fill="none">
        <path d="M2 2H28" stroke={active ? '#000' : '#C7C7C7'} strokeWidth="3" strokeLinecap="round"/>
    </svg>
);

const openExternalLink = (url) => {
    const externalWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (externalWindow) {
        externalWindow.opener = null;
    }
};

const customerStories = [
    {
        id: 'holiday-inn-landscape-55',
        image: img10,
        category: 'HOSPITALITY',
        title: 'How Holiday Inn Enriched Guest Communication with Vieunite’s 55” 4K Textura Pro',
        url: 'https://vieunite.com/news/how-holiday-inn-enriched-guest-communication-with-vieunites-55-4k-textura-pro/',
    },
    {
        id: 'meta',
        image: img8,
        category: 'CORPORATE',
        title: "Meta Invests in Creativity with Vieunite's Textura Pro Digital Art Canvas",
        url: 'https://vieunite.com/VieunitePro-CaseStudy-Meta.pdf',
    },
    {
        id: 'holiday-inn-telford',
        image: img9,
        category: 'HOSPITALITY',
        title: 'Holiday Inn Telford Elevates Guest Experiences With the Vieunite Pro Digital Canvas',
        url: 'https://vieunite.com/VieunitePro-CaseStudy-HolidayInn.pdf',
    },
    {
        id: 'cosimo',
        image: img1,
        category: 'CULTURAL',
        title: 'Cosimo Art Collective Makes Art More Accessible With the Vieunite Digital Canvas',
        url: 'https://vieunite.com/Vieunite_Pro_Use_Case_Cosimo.pdf',
    },
    {
        id: 'hertford-college',
        image: img2,
        category: 'EDUCATION',
        title: 'Vieunite Pro Brings 800 Years of Hertford College, University of Oxford, History to Life with the Textura Pro digital canvas',
        url: 'https://vieunite.com/Vieunite_Pro_Use_Case_Hertford_College_Oxford_University.pdf',
    },
    {
        id: 'stourbridge-glass-museum',
        image: img3,
        category: 'CULTURAL',
        title: 'Stourbridge Glass Museum Celebrated Rich History of Glass Making With Vieunite Pro Digital Canvas',
        url: 'https://vieunite.com/Vieunite_Pro_Use_Case_Stourbridge_Glass_Museum.pdf',
    },
    {
        id: 'uncle-leo',
        image: img4,
        category: 'HOSPITALITY',
        title: "Uncle Leo's Beef Noodle Brings Traditional Lanzhou Food to Birmingham With the Vieunite Pro Digital Canvas",
        url: 'https://vieunite.com/Vieunite_Pro_Use_Case_Uncle_Leo_Noodle.pdf',
    },
    {
        id: 'core-marketing',
        image: img5,
        category: 'CULTURAL',
        title: "Core Marketing's Vision for Modern Office Spaces Comes to Life With Vieunite Pro Digital Canvas",
        url: 'https://vieunite.com/Vieunite_Pro_Use_Case_Core_Marketing.pdf',
    },
    {
        id: 'yoxly',
        image: img6,
        category: 'HOSPITALITY',
        title: 'Yoxly Transforms Their Office Space with the Vieunite Pro Digital Canvas',
        url: 'https://vieunite.com/Vieunite_Pro_Use_Case_Yoxly.pdf',
    },
    {
        id: 'keble-college',
        image: img7,
        category: 'CULTURAL',
        title: 'Keble College creates an engaging and vibrant atmosphere at the HB Allen Centre',
        url: 'https://vieunite.com/Vieunite_Pro_Use_Case_Keble_College.pdf',
    },
];

const CustomerStoriesSlider = memo(({sliderRef, settings, slides}) => (
    <Slider ref={sliderRef} {...settings}>
        {slides}
    </Slider>
));

const CustomerStoriesCarousel = memo(() => {
    const customerStoriesSliderRef = useRef(null);
    const [currentStoryIndex, setCurrentStoryIndex] = useState(0);

    const handleAfterChange = useCallback((current) => {
        setCurrentStoryIndex((previous) => previous === current ? previous : current);
    }, []);

    const customerStoryCarouselSettings = useMemo(() => ({
        infinite: customerStories.length > 3,
        speed: 450,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        draggable: true,
        adaptiveHeight: false,
        arrows: false,
        dots: false,
        afterChange: handleAfterChange,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 760,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                },
            },
            {
                breakpoint: 420,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                },
            },
        ],
    }), [handleAfterChange]);

    const customerStorySlides = useMemo(() => customerStories.map((story) => (
        <div className="pro-case-stories__slide" key={story.id}>
            <article className="pro-case-story-card">
                <button className="pro-case-story-card__media"
                        type="button"
                        onClick={() => openExternalLink(story.url)}
                        aria-label={`Read story: ${story.title}`}>
                    <img src={story.image} alt={story.title}/>
                    <span className="pro-case-story-card__overlay"/>
                    <span className="pro-case-story-card__read">READ STORY</span>
                </button>
                <div className="pro-case-story-card__body">
                    <p className="pro-case-story-card__category">{story.category}</p>
                    <h2>{story.title}</h2>
                </div>
            </article>
        </div>
    )), []);

    return (
        <section className="pro-case-stories" aria-labelledby="pro-case-stories-title">
            <div className='IndustryQuotesTitle pro-case-stories__title' id="pro-case-stories-title">Customer Stories</div>
            <div className="pro-case-stories__carousel">
                <CustomerStoriesSlider
                    sliderRef={customerStoriesSliderRef}
                    settings={customerStoryCarouselSettings}
                    slides={customerStorySlides}
                />
                <div className="pro-case-stories__controls">
                    <button className="pro-case-stories__control-button"
                            type="button"
                            aria-label="Previous customer story"
                            onClick={() => customerStoriesSliderRef.current?.slickPrev()}>
                        <img src={leftScroll} alt=""/>
                    </button>
                    <div className="pro-case-stories__progress" aria-hidden="true">
                        {customerStories.map((story, idx) => (
                            <StoryProgressLine key={story.id} active={idx === currentStoryIndex}/>
                        ))}
                    </div>
                    <button className="pro-case-stories__control-button"
                            type="button"
                            aria-label="Next customer story"
                            onClick={() => customerStoriesSliderRef.current?.slickNext()}>
                        <img src={rightScroll} alt=""/>
                    </button>
                </div>
            </div>
        </section>
    );
});

const ProCaseStudy = (props) => {
    const openFeaturedArticle = () => {
        openExternalLink('https://vieunite.com/news/butcombe-pubs-digital-journey-from-printed-posters-to-textura-pro/');
    };

    return (
        <Layout>
            <Content>
                <div className="pro-case-hero">
                    <img className="pro-case-hero__image" src={butcombeHero} alt="Textura Pro digital canvas at Butcombe’s Brown Cow pub"/>
                    <div className="pro-case-hero__shade"/>
                    <div className="pro-case-hero__content">
                        <div className="pro-case-hero__logo" aria-label="Butcombe Brewing Co.">
                            <img src={butcombeLogo} alt=""/>
                        </div>
                        <h1>BUTCOMBE GOES DIGITAL</h1>
                        <div className="pro-case-hero__actions">
                            <button
                                className="homeMainButton pro-case-hero__button"
                                onClick={openFeaturedArticle}
                            >
                                <span className={'homeMainButtonLnk homeOverV'}>
                                    LEARN MORE
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <CustomerStoriesCarousel/>
                <IndustryQuotes/>
                <ContactSection link={"/pro/support/request-demo"}/>
            </Content>
        </Layout>
    )
}

export default ProCaseStudy;
